import { api, EntityId } from 'api'

export const postInvite = (id: EntityId): Promise<void> => {
  return api({
    method: 'post',
    url: `/api/v1/users/${id}/invite/resend`,
  })
}
